<template>
    <div class="spinner-grow text-dark" :style="spinnerStyle" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</template>

<script>
export default {
    props: {
        small: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        spinnerStyle() {
            let size = 3
            if (this.small) {
                size = 1
            }
            return `width: ${size}rem; height: ${size}rem; min-height: ${size}rem; min-width: ${size}rem;`
        }
    }
}
</script>
